import amplifyconfig from "../../amplifyconfiguration.json";
import { parseAmplifyConfig } from "aws-amplify/utils";

import {
  MBS_OAUTH_RESPONSE_TYPE,
  MBS_OAUTH_SCOPES,
} from "Constants/AuthConstants";

const parsedAmplifyConfig = parseAmplifyConfig(amplifyconfig);

const parseEnvList = (value, fallback = []) =>
  value
    ? value
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
    : fallback;

const mbsEnv = {
  userPoolId: process.env.REACT_APP_MBS_COGNITO_USER_POOL_ID,
  userPoolClientId: process.env.REACT_APP_MBS_COGNITO_USER_POOL_CLIENT_ID,
  oauthDomain: process.env.REACT_APP_MBS_OAUTH_DOMAIN,
  oauthRedirectSignIn: process.env.REACT_APP_MBS_OAUTH_REDIRECT_SIGN_IN,
  oauthRedirectSignOut: process.env.REACT_APP_MBS_OAUTH_REDIRECT_SIGN_OUT,
};

const mbsOAuthRedirectSignIn = parseEnvList(mbsEnv.oauthRedirectSignIn);
const mbsOAuthRedirectSignOut = parseEnvList(mbsEnv.oauthRedirectSignOut);

const hasMbsOAuthEnv = Boolean(
  mbsEnv.oauthDomain &&
  mbsOAuthRedirectSignIn.length &&
  mbsOAuthRedirectSignOut.length
);

export const mbsAmplifyConfig = {
  ...parsedAmplifyConfig,
  Auth: {
    Cognito: {
      userPoolId: mbsEnv.userPoolId,
      userPoolClientId: mbsEnv.userPoolClientId,
      loginWith: {
        username: true,
        ...(hasMbsOAuthEnv
          ? {
              oauth: {
                domain: mbsEnv.oauthDomain,
                redirectSignIn: mbsOAuthRedirectSignIn,
                redirectSignOut: mbsOAuthRedirectSignOut,
                responseType: MBS_OAUTH_RESPONSE_TYPE,
                scopes: MBS_OAUTH_SCOPES,
              },
            }
          : {}),
      },
    },
  },
};

export const hasValidMBSAmplifyConfig = () =>
  Boolean(
    mbsAmplifyConfig.Auth.Cognito.userPoolId &&
    mbsAmplifyConfig.Auth.Cognito.userPoolClientId
  );

export const hasValidMBSSsoConfig = () =>
  Boolean(
    hasValidMBSAmplifyConfig() &&
    mbsAmplifyConfig.Auth.Cognito.loginWith?.oauth?.domain &&
    mbsAmplifyConfig.Auth.Cognito.loginWith?.oauth?.redirectSignIn?.length &&
    mbsAmplifyConfig.Auth.Cognito.loginWith?.oauth?.redirectSignOut?.length
  );
